import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppLayout } from './AppLayout';

/**
 * Layout component for organization-level routes (/dashboard/*)
 * Shows header but no project sidebar
 */
export const OrgRouteLayout: React.FC = () => {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};
